module.exports = __webpack_public_path__ + "static/media/how-does-it-work.5f9dfca7.md";